<script setup lang="ts">
	definePageMeta({
		auth: false
	});

	const isMounted = ref(false);

	onMounted(() => {
		isMounted.value = true;
	});
</script>

<template>
	<div class="landing">
		<PagesMainSection1 />
		<PagesMainSection2 />
		<PagesMainSection3 />
		<PagesMainSectionReview />
		<PagesMainSection4 />
		<LazyPagesMainSectionFooter v-if="isMounted" />
	</div>
</template>

<style scoped lang="scss">
	.landing {
		display: flex;
		flex-direction: column;
		min-height: 100vh;
		//background: radial-gradient(circle at top, #1d4ed8, #020617);

		color: white;
		height: 100%;
		min-height: max-content;
	}
</style>
